<template>
      <div class="flex items-center divide-[#DBDBDC] md:absolute right-0">
          <p class="flex items-center justify-end text-[12px] text-won-dark-gray w-[103px] h-[24px] mr-5">
              Regenerate:</p>
          <div class="flex items-center justify-between">
              <button
                  v-tooltip="{
                        content: 'Select a paragraph to regenerate',
                        placement: 'bottom',
                        popperClass: '!text-center !text-[12px] !leading-[16px] font-[Roboto] px-2 py-1 bg-dark-won-blue text-white'
                  }"
                  :class="[
                      'border pt-1.5 pr-3 pb-1.5 pl-3 text-[12px] mr-1 rounded-md',
                      isEnableRegenerateText ? 'border-won-green text-won-green': 'border-won-gray-light text-won-gray-light'
                  ]"
                  @click="emit('regenerate')"
                  :disabled="!isEnableRegenerateText"
              >
                  Selected Text
              </button>

              <button
                  class="border border-won-green text-won-green pt-1.5 pr-3 pb-1.5 pl-3 text-[12px] rounded-md mr-4"
                  @click="emit('regenerate', true)">
                  All Text
              </button>
          </div>
      </div>
</template>

<script setup>
import { defineEmits } from 'vue'
import { storeToRefs } from "pinia";
import { useTiptapStore } from "../../store/tiptap.store";

const emit = defineEmits(["regenerate"]);

const tipTapEditor = useTiptapStore()
const { isEnableRegenerateText } = storeToRefs(tipTapEditor)
</script>
